import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Select from "../../../components/ui/Select";
import Input from "../../../components/ui/Input";
import httpHelper, { Method_TYPE } from "../../../utils/http-helper";
import URL_CONSTANTS from "../../../constants/url-constants";
import { calculateAge } from "utils/calculateAge";
import { isMemberBlocked } from "utils/member-utils";

const EditServicePage = ({ member, loading, setShowEditModal }) => {
  const [selectedDeploymentPoint, setSelectedDeploymentPoint] = useState("");
  const [notes, setNotes] = useState("");
  const [deploymentDetails, setDeploymentDetails] = useState([]);
  const [batchDetails, setBatchDetails] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [serviceHistory, setServiceHistory] = useState([]);
  const [memberInfo, setMemberInfo] = useState({})
  const [currentBatchObj, setCurrentBatchObj] = useState({});
  const [groupLeaders, setGroupLeaders] = useState([]);
  const [requiredCount,setRequiredCount] = useState(0);
  const [allocatedCount, setAllocatedCount] = useState(0);
  const [loadingState, setLoading] = useState(loading);
  const [isActionAllowed,setISActionAllowed] = useState(true)

  useEffect(() => {
    fetchDeploymentPointMeta();
    getCurrentBatch();
    fetchMemberServices();
    fetchGroupLeaderInfo();
    setLoading(loading)
  }, []);

  useEffect(() => {
    if (member) {
      setSelectedBatch("");
      setSelectedDeploymentPoint("");
      setNotes("");
    }
  }, [member]);

  const getCurrentBatch = async () => {
    try {
      const data = await httpHelper(
        URL_CONSTANTS.GET_CURRENT_BATCH_DETAILS,
        Method_TYPE.GET
      );
      setSelectedBatch(data?._id || "");
      setCurrentBatchObj(data);
      setBatchDetails(
        data?.period?.batches?.filter(val => val?._id === data?._id).map((val) => ({
          label: val?.name,
          value: val?._id,
        }))
      );
    } catch (err) {
      console.error("Error fetching batch details:", err);
    }
  };

  const fetchGroupLeaderInfo = async () => {
    try {
      const groupLeaderInfo = await httpHelper(`${URL_CONSTANTS.GROUP_LEADER_INFO}`, Method_TYPE.GET);
      setGroupLeaders(groupLeaderInfo || []);
    }
    catch (err) {
      console.log(err);
      setGroupLeaders([]);
    }
  }

  const fetchDeploymentPointMeta = async () => {
    try {
      const response = await httpHelper(
        `${URL_CONSTANTS.DEPLOYMENT_POINTS}/${member?.id}`,
        Method_TYPE.GET
      );
      setDeploymentDetails(
        response?.map((res) => ({
          label: res?.name,
          value: res?._id,
          sector: res?.sector
        }))
      );
    } catch (err) {
      console.log("Fetch deployment point meta error", err);
    }
  };

  const fetchMemberServices = async () => {
    try {
      const response = await httpHelper(
        `${URL_CONSTANTS.GET_SERVICE_MEMBER_INFO}/${member?.id}`,
        Method_TYPE.GET
      );
      setServiceHistory(
        response?.data?.map((res) => ({
          servicePlace: res?.deploymentpoint?.name,
          batch: res?.batch?.name,

        }))
      );
      setMemberInfo(response?.data[0])

    } catch (err) {
      console.log("Fetch member services error", err);
    }
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      if(allocatedCount >= requiredCount){
        alert('Required count has been met.You cannot assign more members to this deployment point.')
        return;
       }

      const data = {
        samithi: memberInfo?.member?.samithi?._id,
        member: memberInfo?.member?._id,
        district: memberInfo?.member?.district?._id,
        batch: selectedBatch,
        deploymentpoint: selectedDeploymentPoint,
        sector: deploymentDetails.find(x => x.value === selectedDeploymentPoint)?.sector || '',
  
      }

     await httpHelper(`${URL_CONSTANTS.SERVICE}${member?.servicePointId}`, Method_TYPE.PUT, data);
      
      handleBack()
    } 
    catch (err) {
      console.log(err)
    }

  };

  const assignAndPrint = async () => {

    try {

      if(allocatedCount >= requiredCount){
        alert('Required count has been met.You cannot assign more members to this deployment point.')
        return;
       }

      const data = {
        samithi: memberInfo?.member?.samithi?._id,
        member: memberInfo?.member?._id,
        district: memberInfo?.member?.district?._id,
        batch: selectedBatch,
        deploymentpoint: selectedDeploymentPoint,
        sector: deploymentDetails.find(x => x.value === selectedDeploymentPoint)?.sector || '',

      }

      
      await httpHelper(`${URL_CONSTANTS.SERVICE}${member?.servicePointId}`, Method_TYPE.PUT, data);
      
      const printMemberObj = {
        id: memberInfo.member._id,
        name: memberInfo?.member?.name || '',
        age: calculateAge(memberInfo?.member?.dob),
        saiOneId: memberInfo.member?.saiOneId || '------',
        mobNo: memberInfo.member?.mobNoPrimary || "------",
        district: memberInfo.member?.district?.districtName || "------",
        samithi: memberInfo.member?.samithi?.samithiName || "-----",
        bloodGroup: memberInfo.member?.bloodGroup || "----",
        servicePoint: deploymentDetails.find(x => x.value === selectedDeploymentPoint)?.label || '',

      }
      const matchedLeader = groupLeaders.find(leader => leader.sector._id === data.sector);
      sessionStorage.setItem('pMember', JSON.stringify(printMemberObj));
      sessionStorage.setItem('pGLeader', JSON.stringify(matchedLeader || null));
      sessionStorage.setItem('pCurrentBatch', JSON.stringify(currentBatchObj || null));
      window.open("/printCard", "_blank");
      handleBack()
    } catch (err) {
      console.log(err)
    }

  };

  const handleBack = () => {
    setShowEditModal(false);
    setTimeout(() => {
      window.location.reload();
    }
      , 1500);

    //navigate('unallocated-members-management')}
  };

  const onChangeDeploymentPoint = async (value) => {
     setLoading(true)
     setSelectedDeploymentPoint(value);
     const deploymentResult = await httpHelper(`${URL_CONSTANTS.DEPLOYMENT_POINTS}/${selectedBatch}`, Method_TYPE.GET);
     const deployment = deploymentResult.filter(dep => dep._id === value);
     const allocCount = deployment[0]?.allocatedCount || 0;
     const reqCount = deployment[0]?.reqCount || 0;
     setAllocatedCount(deployment[0]?.allocatedCount || 0);
     setRequiredCount(deployment[0]?.reqCount || 0);
     setLoading(false)
  }


  if (!member) return <p>No member data</p>;

  return (
    <div className=" bg-gray-50 p-4 pt-0 max-w-7xl mx-auto px-4 lg:px-6">
      <form onSubmit={handleSubmit}>
        {/* Header */}
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4 flex items-center">
            <div className="flex items-center space-x-3 w-8 h-8 bg-orange-500 rounded-lg justify-center mr-3">
              <Icon name="User" size={16} className="text-white" />
            </div>
            <div>
              <h1 className="text-lg font-semibold text-gray-900">
                Member Service Allocation
              </h1>
              <p className="text-xs text-gray-600">
                Manage service point assignment
              </p>
            </div>
          </div>
        </div>

        {/* Member Details */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 pr-11 mb-4">
          <div className="grid grid-cols-2 gap-4 text-sm md:flex justify-between">
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Name
              </label>
              <span className="font-semibold text-gray-900">{(memberInfo?.member?.name) ? memberInfo?.member?.name : "---"}</span>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Sai Connected Id
              </label>
              <span className="font-semibold text-gray-900">
                {memberInfo?.member?.saiOneId ? memberInfo?.member?.saiOneId : "---"}
              </span>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Pmc.no
              </label>
              <span className="font-semibold text-gray-900">
                {memberInfo?.member?.pmcNo ? memberInfo?.member?.pmcNo : "---"}
              </span>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Mobile
              </label>
              <span className="font-semibold text-gray-900">
                {memberInfo?.member?.mobNoPrimary ? memberInfo?.member?.mobNoPrimary : "---"}
              </span>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Age
              </label>
              <span className="font-semibold text-gray-900">
                {memberInfo?.member?.dob ? calculateAge(memberInfo?.member?.dob) : "---"}
              </span>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                District
              </label>
              <span className="font-semibold text-gray-900">
                {memberInfo?.member?.district?.districtName ? memberInfo?.member?.district?.districtName : '---'}
              </span>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Blood Groups
              </label>
              <span className="font-semibold text-gray-900">
                {memberInfo?.member?.bloodGroup ? memberInfo?.member?.bloodGroup : '---'}
              </span>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Samithi
              </label>
              <span className="font-semibold text-gray-900">
                {memberInfo?.member?.samithi?.samithiName ? memberInfo?.member?.samithi?.samithiName : "---"}
              </span>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Status
              </label>
              <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${
                isMemberBlocked(memberInfo?.member || member)
                  ? 'bg-red-100 text-red-700 border border-red-300'
                  : 'bg-green-100 text-green-700 border border-green-300'
              }`}>
                {isMemberBlocked(memberInfo?.member || member) ? "Blocked" : "Active"}
              </span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:max-h-[calc(100vh-380px)]">
          {/* Service History */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 flex-1 h-full">
            <h2 className="text-base font-semibold text-gray-900 flex items-center mb-3">
              <Icon name="Calendar" size={16} className="text-primary mr-2" />
              Service History
            </h2>
            <div className="overflow-y-auto max-h-72 space-y-2 text-lg">
              {serviceHistory?.map((service, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center p-2 bg-gray-50 rounded"
                >
                  <div className="font-medium text-gray-800 truncate">
                    {service?.batch ? service?.batch : '---'}
                  </div>
                  <span className="px-2 py-1 rounded-full bg-orange-100 text-orange-800">
                    {service?.servicePlace ? service?.servicePlace : '---'}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Service Assignment */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full p-4 flex flex-col">
            <h2 className="text-base font-semibold text-gray-900 flex items-center mb-4">
              <Icon name="Calendar" size={16} className="text-primary mr-2" />
              Service Assignment
            </h2>
            <div className="flex flex-col gap-5">
              <Select
                label="Select Batch"
                placeholder="Assign a batch..."
                options={batchDetails}
                value={selectedBatch}
                onChange={(value) => setSelectedBatch(value)}
                required
                searchable
              />
              <Select
                label="Select Deployment Point"
                placeholder="Assign deployment point..."
                options={deploymentDetails}
                value={selectedDeploymentPoint}
                onChange={onChangeDeploymentPoint}
                required
                searchable
              />
            </div>
            <div className="bg-muted/30 rounded-lg p-4">
            <h3 className="font-heading font-medium text-foreground mb-3 flex items-center space-x-2">
              <Icon name="User" size={18} className="text-primary" />
              <span>Allocation Details</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-lg">
              <div>
                <span className="text-muted-foreground">Required:</span>
                <p className="font-medium text-foreground">{requiredCount}</p>
              </div>
              <div>
                <span className="text-muted-foreground">Allocated:</span>
                <p className="font-mono text-foreground">{allocatedCount}</p>
              </div>
            </div>
          </div>

            {/* Buttons */}
            {isActionAllowed &&
            <div className="flex gap-3 justify-end pt-4 border-t border-gray-100 mt-auto">
              <Button
                type="button"
                variant="outlined"
                onClick={handleBack}
                disabled={loadingState}
              >
                Cancel
              </Button>
              {  <Button
                type="submit"
                variant="default"
                loading={loadingState}
                disabled={(!selectedBatch || !selectedDeploymentPoint)}
                iconName="UserCheck"
                iconPosition="left"
              >
                Assign to Service
              </Button> }
              <Button
                type="button"
                variant="default"
                onClick={assignAndPrint}
                loading={loadingState}
                disabled={(!selectedBatch || !selectedDeploymentPoint )}
                iconName="UserCheck"
                iconPosition="left"
              >
                Assign & Print
              </Button>
            </div>
            }
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditServicePage;
